import { ModalOrder } from "./modalOrder";
import { ModalSuccess } from "./modalSuccess";
import { ModalMobileFilters } from "./modalMobileFilters";

export const modals = {
  ModalOrder,
  ModalSuccess,
  ModalMobileFilters,
};
